<template>
  <div class="dashboard">
    <va-card>
      <div class="row">
        <div class="col-md-12">
          <va-tabs
            grow
            v-model="tabsState"
          >
            <va-tab
              v-for="(tab, index) in tabs"
              :key="index"
              :title="tab.title"
            > {{ tab.title }}

            </va-tab>

          </va-tabs>

        </div>
      </div>

      <va-separator />
      <div
        class="row"
        v-if="activeTab"
      >
        <div class="col-md-12">
          <component :is="activeTab.component" />
        </div>
      </div>
    </va-card>
  </div>
</template>
  
  <script>

import ListFormationModel from "./components/list-formation-model.vue";
import listFormateurs from "./components/list-formateurs.vue";
import listLieux from "./components/list-lieux.vue";

export default {
  name: "liste_formations",
  components: {

    "list-formation-model": ListFormationModel,
    "list-formateurs": listFormateurs,
    "list-lieux": listLieux,
  },
  data() {
    return {
      tabsState: 0,
      tabs: [
        {
          title: "Modèle de formation",
          component: "list-formation-model",
        },
        {
          title: "Formateurs",
          component: "list-formateurs",
        },
        {
          title: "Lieux",
          component: "list-lieux",
        },
      ],
      activeTab: null,
    };
  },
  methods: {},
  mounted() {
    this.activeTab = this.tabs[this.tabsState];
  },
  watch: {
    tabsState() {
      this.activeTab = this.tabs[this.tabsState]
    },
  },
};
  </script>
  
  <style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0;
  }
}
</style>
  